import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import FrayedDivider from '@/components/schools/FrayedDivider';
import GridWrapper from '@/components/ui/GridWrapper';
import rightArrow from 'icons/right-arrow.svg';
import logo from 'icons/schools-logo.svg';

export const Wrapper = styled.section`
	background: ${palette('schoolBlue')};
	display: flex;
	flex-direction: column-reverse;
	overflow: hidden;
	position: relative;
	z-index: 0;

	${minWidth('tablet')} {
		background: transparent;
		display: block;
		padding: 32px 0 52px;
	}

	${minWidth('desktop')} {
		padding: 52px 0 100px;
	}

	${minWidth('desktopLarge')} {
		padding: 98px 0 140px;
	}
`;

export const Background = styled(FullscreenBackground)`
	display: none;

	${minWidth('tablet')} {
		display: block;
		height: auto;
		left: 50%;
		max-width: 1440px;
		position: absolute;
		transform: translateX(-50%);
		width: 100%;
	}
`;

export const Grid = styled(GridWrapper)``;

export const Content = styled.div`
	color: ${palette('white')};
	padding-top: 52px;

	${minWidth('mobileLarge')} {
		padding-top: 60px;
	}

	${minWidth('tablet')} {
		padding-top: 0;
		width: 50%;
	}
`;

export const Logo = styled(logo)`
	margin-bottom: 24px;
	height: 52px;
	width: auto;

	${minWidth('tablet')} {
		height: 64px;
	}

	${minWidth('desktop')} {
		height: 84px;
		margin-bottom: 32px;
	}
`;

export const Heading = styled.h2`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 24px;

	${minWidth('desktop')} {
		margin-bottom: 32px;
		${fontWeight(FontWeights.Medium)};
	}
`;

export const Arrow = styled(rightArrow)`
	margin-left: 10px;
	transition: ${theme('animation.transition')};
`;

export const Cta = styled(Button)`
	overflow: visible;
	padding: 0;

	${minWidth('desktop')} {
		&:hover {
			&:before {
				opacity: 0;
			}

			${Arrow} {
				transform: translateX(4px);
			}
		}
	}
`;

export const MobileImage = styled.div`
	height: 30vh;
	vertical-align: bottom;
	width: 100%;

	${minWidth('tablet')} {
		display: none;
	}
`;

export const Image = styled(FullscreenBackground)`
	display: none;

	${minWidth('tablet')} {
		bottom: 84px;
		display: block;
		left: 50%;
		margin-left: 20px;
		max-width: 690px;
		position: absolute;
		top: 0;
		width: calc(50% - 20px);
	}

	${minWidth('desktop')} {
		margin-left: 30px;
		width: calc(50% - 30px);
	}
`;

export const Divider = styled(FrayedDivider)`
	${minWidth('tablet')} {
		display: none;
	}
`;
